import styled from 'styled-components/native';
import { withDefaultTypographyProps } from '../index.shared';

const H3 = styled(withDefaultTypographyProps)`
  font-size: ${(props) => props.theme.FONT_SIZES.V2_H3.DEFAULT}px;
  line-height: ${(props) => props.theme.FONT_SIZES.V2_H3.DEFAULT * 1.5}px;
`;

H3.defaultProps = {
  fontWeight: 'bold',
  fontStyle: 'normal',
};

export default H3;
